export class GeneralInfo {
    legalName: string;
    dba: string;
    businessName: string;

    legalAddressLine1: string;
    legalAddressLine2: string;
    legalCity: string;
    legalState: string;
    legalCountry: string;
    legalZipcode: number;
    duns: number;
    mainPhone: number;
    mainFax: number;
    website: string;
    dbaAddressline1: string;
    dbaAddressline2: string;

    dbaCity: string;
    dbaState: string;
    dbaCountry: string;
    dbaZipcode: number;

    generalInfoAddressType: string;
    shipbillAddress: string;
    shipbillCity: string;
    shipbillState: string;
    shipbillCountry: string;
    shipbillZipcode: number;
    shipbillCompanyName: string;
    shipbillcontactType: string;

    naicscode: number;
}